import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { HEATING_PROGRAMS_PATH } from '../../core/constants';

export const getAllHeatingProgramsAction = createAsyncThunk(
    'product/getAllHeatingProgramsAction',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ HEATING_PROGRAMS_PATH }/all`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getAllHeatingProgramsSlice = createSlice({
    name: 'getAllHeatingProgramsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getAllHeatingProgramsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getAllHeatingProgramsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getAllHeatingProgramsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getAllHeatingProgramsState = (state) => state.product.getAllHeatingPrograms;
export default getAllHeatingProgramsSlice.reducer;
